import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://towardsai-tutors-buster.hf.space?__theme=light",
  frameborder: "0",
  width: "100%",
  style: {"height":"100vh","max-height":"1100px"},
  class: "blur-glass"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    "fill-height": "",
    class: "blue-background"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, { class: "d-flex justify-center" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}